import "./src/styles/global.css";
import type { GatsbyBrowser } from "gatsby";

const revealSelector = [
  ".section-heading",
  ".trust-item",
  ".product-card",
  ".step-card",
  ".delivery-card",
  ".testimonial",
  ".faq-item",
  ".split-section > div",
  ".order-panel",
  ".contact-band > div",
  ".catalog-hero > div",
  ".catalog-product",
  ".catalog-cta > div",
  ".catalog-cta > a",
  ".product-gallery",
  ".product-detail-copy",
  ".info-card",
  ".related-card",
].join(",");

function setupScrollReveal() {
  if (typeof window === "undefined" || !("IntersectionObserver" in window)) {
    return;
  }

  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

  if (reducedMotion.matches) {
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        }
      });
    },
    {
      rootMargin: "0px 0px -4% 0px",
      threshold: 0.08,
    },
  );

  document.querySelectorAll<HTMLElement>(revealSelector).forEach((element) => {
    if (element.dataset.revealReady === "true") {
      return;
    }

    element.dataset.revealReady = "true";

    const rect = element.getBoundingClientRect();
    const isAlreadyInView = rect.top < window.innerHeight * 0.98 && rect.bottom > 0;

    element.classList.add("reveal-on-scroll");

    if (isAlreadyInView) {
      element.classList.add("is-visible");
      return;
    }

    observer.observe(element);
  });
}

export const onClientEntry = () => {
  window.requestAnimationFrame(setupScrollReveal);
};

export const onRouteUpdate = () => {
  window.requestAnimationFrame(setupScrollReveal);
};

export const shouldUpdateScroll: GatsbyBrowser["shouldUpdateScroll"] = ({
  routerProps,
  prevRouterProps,
}) => {
  const nextLocation = routerProps.location;
  const previousLocation = prevRouterProps?.location;

  if (nextLocation.hash) {
    return true;
  }

  if (previousLocation?.pathname !== nextLocation.pathname) {
    window.requestAnimationFrame(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    });

    return false;
  }

  return true;
};
